import { registerTour } from "../tourRegistry";

function waitForElement(selector, timeout = 5000) {
  return new Promise((resolve) => {
    const el = document.querySelector(selector);
    if (el) { resolve(); return; }
    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => { observer.disconnect(); resolve(); }, timeout);
  });
}

function getSteps() {
  const totalSteps = 6;
  const stepCounter = (n) => `<span class="t3-shepherd-step-count" aria-hidden="true">Step ${n} of ${totalSteps}</span>`;

  return [
    {
      id: 'imported-page',
      title: `Imported Transactions ${stepCounter(1)}`,
      text: 'Review and categorize transactions imported from your bank or CSV file. Each transaction needs an account, fund, and contact before it can be added to your books.',
      attachTo: { element: '[data-tour="imported-page"]', on: 'bottom' },
      buttons: [
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'imported-tabs',
      title: `Status Tabs ${stepCounter(2)}`,
      text: 'Transactions are organized by status: <strong>Unmatched</strong> need your attention, <strong>Matched</strong> are ready to go, <strong>Submitted</strong> are processing, and <strong>Errors</strong> need fixes.',
      attachTo: { element: '[data-tour="imported-tabs"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'imported-predictions',
      title: `Smart Predictions ${stepCounter(3)}`,
      text: "T3 Books predicts the account, fund, and contact for each transaction based on past patterns. Look for the colored badges — 'Auto' means high-confidence match.",
      attachTo: { element: '[data-tour="imported-prediction-example"]', on: 'bottom' },
      beforeShowPromise() {
        return waitForElement('[data-tour="imported-prediction-example"]');
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'imported-row-actions',
      title: `Row Actions ${stepCounter(4)}`,
      text: 'Each transaction has action buttons: <strong>Split</strong> divides a transaction across multiple accounts, <strong>Submit</strong> (green checkmark) adds it to your books, and <strong>Delete</strong> removes it.',
      attachTo: { element: '[data-tour="imported-row-actions"]', on: 'left' },
      beforeShowPromise() {
        return waitForElement('[data-tour="imported-row-actions"]');
      },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'imported-batch-actions',
      title: `Batch Operations ${stepCounter(5)}`,
      text: 'Save time by selecting multiple transactions and assigning contacts, accounts, or funds in bulk. Use the checkboxes to select, then apply changes to all selected at once.',
      attachTo: { element: '[data-tour="imported-batch-actions"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Next',
          classes: 't3-shepherd-next-btn',
          action() { this.next(); },
        },
      ],
    },
    {
      id: 'imported-submit',
      title: `Submit ${stepCounter(6)}`,
      text: 'Once transactions are matched, submit them to add to your books. Submitted transactions sync to BigQuery instantly and appear in all reports.',
      attachTo: { element: '[data-tour="imported-submit"]', on: 'bottom' },
      buttons: [
        {
          text: 'Back',
          classes: 't3-shepherd-back-btn',
          action() { this.back(); },
        },
        {
          text: 'Done',
          classes: 't3-shepherd-next-btn',
          action() { this.complete(); },
        },
      ],
    },
  ];
}

registerTour({
  id: 'importedTransactions',
  pathPattern: new RegExp('^/banking/.+/handle-imported'),
  getSteps,
  label: 'Imported Transactions Tour',
});
